import React from "react";
import title from "global/constants/TitleConstants";
import { isAdmin } from "layouts/Config";
import { useTitle } from "utils/UseTitle";
import SettingsLayout from "screens/Settings/components/SettingsLayout";
import MfaEnforcementCard from "./components/MfaEnforcementCard";
import PasswordExpiryCard from "./components/PasswordExpiryCard";
import WhitelistIpsSection from "./components/WhitelistIpsSection";

const SecurityPolicies = () => {
  useTitle(title.SECURITY_POLICIES);
  const admin = isAdmin();

  return (
    <SettingsLayout activeTab="Security Policies" title="Security Policies">
      {admin && <PasswordExpiryCard />}
      {admin && <MfaEnforcementCard />}
      {admin && <WhitelistIpsSection />}
    </SettingsLayout>
  );
};

export default SecurityPolicies;
